module.exports = __webpack_public_path__ + "mx.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/mx.svg
// module id = 971
// module chunks = 0